.portionsContainer {
  display: grid;
  grid-template-columns: repeat(7, 2rem);
  column-gap: 1rem;
  row-gap: 0.5rem;
}
